import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Input } from './Input';
export var PopupInput = /*#__PURE__*/function (_React$Component) {
  _inherits(PopupInput, _React$Component);
  var _super = _createSuper(PopupInput);
  function PopupInput() {
    var _this;
    _classCallCheck(this, PopupInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "ref", null);
    _defineProperty(_assertThisInitialized(_this), "handleInnerRef", function (ref) {
      _this.ref = ref;
      if (_this.props.innerRef) {
        _this.props.innerRef(ref);
      }
    });
    return _this;
  }
  _createClass(PopupInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.ref) {
        // @ts-ignore
        this.ref.select();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Input, _extends({}, this.props, {
        innerRef: this.handleInnerRef
      }));
    }
  }]);
  return PopupInput;
}(React.Component);